import { useCallback, useRef, useState } from "react";

/**
 * Returns { run, loading } where run(asyncFn) executes asyncFn once at a time
 * and toggles loading for disabling sibling controls (inputs, etc.).
 */
export function useAsyncAction() {
  const [loading, setLoading] = useState(false);
  const pendingRef = useRef(false);

  const run = useCallback(async (asyncFn) => {
    if (pendingRef.current || typeof asyncFn !== "function") {
      return;
    }
    pendingRef.current = true;
    setLoading(true);
    try {
      return await asyncFn();
    } finally {
      pendingRef.current = false;
      setLoading(false);
    }
  }, []);

  return { run, loading };
}
